/* eslint-disable eqeqeq */
import React, { useState, useEffect } from "react";
import API from "../../utils/API";
import Html from "../../utils/Html";
import "./style.css";
import TopContent from "./top.content";
import MainContent from "./main.content";

const Container = (props) => {
  let userData = window.$user_profile;
  const [userLeave, setUserLeave] = useState({ data: "", err: 0, err_msg: "" });
  useEffect(() => {
    if (userData?.idu != 0) {
      const mainFunc = async () =>
        await API.post("user/leave", {
          params: { userID: userData.idu },
        });

      mainFunc()
        .then((res) => {
          const decrypt = res?.data;
          // console.log("alluser export=", decrypt);
          if (decrypt?.status === "success") {
            setUserLeave(decrypt);
          } else {
            setUserLeave({
              err: 1,
              err_msg: `Failes : ` + decrypt?.err_msg ?? "",
            });
          }
        })
        .catch((err) => {
          setUserLeave({ err: 1, err_msg: `Failes : ${err}` });
        });
    }
  }, [userData?.idu]);
  if (userLeave.err === 1) {
    return <div>Fetch request error: {userLeave.err_msg}</div>;
  } else if (userLeave.data === "") {
    return (
      <div>
        <Html.Preloading
          addon={{
            css: {
              position: "absolute",
              top: "0",
              left: "0",
              right: "0",
              bottom: "0",
              margin: "auto",
            },
          }}
        />
      </div>
    );
  }
  userData.user_leave = userLeave.data;
  //console.log("hello");
  return (
    <div>
      <TopContent data={userData} />
      <MainContent userID={userData.idu} />
    </div>
  );
};
export default Container;
